import React from 'react'
import Link from '../Link'
import { useTranslation } from 'react-i18next'
import LogoLight from '../../assets/image/svg/LightModeCoinigyLogo.inline.svg'
import LogoDark from '../../assets/image/svg/DarkModeCoinigyLogo.inline.svg'
import { useStaticQuery, graphql } from 'gatsby'

interface LogoProps {
  layout?: string;
  className?: string;
  white?: boolean;
  height?: number;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

interface SiteMetadata {
  site: {
    siteMetadata: {
      languages: string[];
    };
  };
}

const Logo: React.FC<LogoProps> = ({ 
  layout, 
  white, 
  height, 
  className = '', 
  ...rest 
}) => {
  const { i18n } = useTranslation()
  const metaData = useStaticQuery<SiteMetadata>(
    graphql`
      query {
        site {
          siteMetadata {
            languages
          }
        }
      }
    `
  )
  const langs = metaData.site.siteMetadata.languages
  let i18nLang: string | undefined
  let lang: string

  if (typeof i18n.language !== 'undefined') {
    i18nLang = i18n.language.includes('-')
      ? i18n.language.split('-')[0]
      : i18n.language
  }

  lang =
    typeof langs.find(lang => lang === i18nLang) !== 'undefined'
      ? langs.find(lang => lang === i18nLang) || 'en'
      : 'en'

  return (
    <Link
      to={layout !== 'services' ? `/${lang}/` : `/${lang}/services`}
      className={`${className}`}
      {...rest}
    >
      {white ? (
        <LogoDark
          width="183px"
          height="40px"
          aria-label="Lightspeed Crypto"
          role="img"
        />
      ) : (
        <LogoLight
          width="183px"
          height="40px"
          aria-label="Lightspeed Crypto"
          role="img"
        />
      )}
    </Link>
  )
}

export default Logo
